<template>
  <div class="main-trigger">

    <main>
      <header>
        <h3>触发器管理</h3>
        <div class="btn-group">

            <a-button   :disabled="this.selectedJobRowKeys.length>0 ? false:true"  @click="batchOpen(1)">
              <i class="table-batch_file"></i>
              批量启用
            </a-button>
            <a-button  :disabled="this.selectedJobRowKeys.length>0 ? false:true" @click="batchOpen(0)">
              <i class="table-bulk_disable" ></i>
              批量禁用
            </a-button>
            <a-button   :disabled="this.selectedJobRowKeys.length>0 ? false:true"  @click="batchOpen(3)">
              <i class="table-delected" ></i>
              批量删除
            </a-button>
          <a-button v-if="$IA('system:schedule:save')" type="primary" icon="plus" @click="addTriggerleont"
          >添加</a-button
          >
        </div>
        <!-- <span>/ trigger management</span> -->
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText" >
            <a-input-search
                v-model.trim="pagination.searchText"
                placeholder="名称/流程/环境/机器人"
                style="width: 200px; "
                allow-clear
                :loading="btnLoad"
                @input="searchTextChange"
                @search="searchChange"
            />
          </a-form-model-item>

          <a-form-model-item prop="type" >
            <a-select
                placeholder="类型"
                v-model="pagination.type"
                style="width: 180px; "
                :loading="btnLoad"
                allow-clear
                @change="searchChange"
            >
              <a-select-option
                  v-for="(v, index) in this.typeName"
                  :key="index"
                  :value="index"
              >{{ v }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="state" >
            <a-select
                placeholder="状态"
                v-model="pagination.state"
                style="width: 180px; "
                :loading="btnLoad"
                allow-clear
                @change="searchChange"
            >
              <a-select-option :value="1">启用</a-select-option>
              <a-select-option :value="0">禁用</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-tree-select
                v-model='pagination.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                style="width: 180px; "
                @change="searchChange"
                placeholder="选择部门"
                show-search
                :filterTreeNode="filter_tree_node"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item prop="priority" >
            <a-select
                placeholder="作业优先级"
                v-model="pagination.priority"
                style="width: 180px;"
                :loading="btnLoad"
                allow-clear
                @change="searchChange"
            >
              <a-select-option :value="0">低</a-select-option>
              <a-select-option :value="1">中</a-select-option>
              <a-select-option :value="2">高</a-select-option>
              <a-select-option :value="3">已继承</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item  >
            <a-button  @click="resetSearch" style="width: 74px">重 置</a-button>
          </a-form-model-item>

        </a-form-model>

      </div>
      <!-- 数据表格 -->
      <a-table
          :columns="tableColumns"
          :data-source="tableData"
          :pagination="queryCondition"
          :loading="tableLoad"
          @change="handleTableChange"
          rowKey="id"
          bordered
          :rowSelection='rowtriggerSelection'
          :scroll="{ y: 560 }"
      >
        <template slot="name" slot-scope="text, record">
          <img
              v-if="record.state === 0 && record.type === 2"
              src="../assets/images/time_disable.png"
              alt=""
              class="img-lc"
          />
          <img
              v-if="record.state === 1 && record.type === 2"
              src="../assets/images/time_enable.png"
              alt=""
              class="img-lc"
          />
          <img
              v-if="record.state === 0 && record.type === 3"
              src="../assets/images/queue_disable.png"
              alt=""
              class="img-lc"
          />
          <img
              v-if="record.state === 1 && record.type === 3"
              src="../assets/images/queue_enable.png"
              alt=""
              class="img-lc"
          />
          <img
              v-if="record.state === 0 && record.type === 4"
              src="../assets/images/email_traDisable.png"
              alt=""
              class="img-lc"
          />
          <img
              v-if="record.state === 1 && record.type === 4"
              src="../assets/images/email_traSelected.png"
              alt=""
              class="img-lc"
          />
          <img
              v-if="record.state === 0 && record.type === 5"
              src="../assets/images/folder_traDisable.png"
              alt=""
              class="img-lc"
          />
          <img
              v-if="record.state === 1 && record.type === 5"
              src="../assets/images/folder_traSelected.png"
              alt=""
              class="img-lc"
          />
          <span :title="text">{{ text }}</span>
        </template>
        <template slot="type" slot-scope="text">
          <span>{{ typeName[text] }}</span>
        </template>
        <template slot="nextTime" slot-scope="text,record">
          <span :title="nextTimeShow(record)">{{ nextTimeShow(record) }}</span>
        </template>
        <template slot="priority" slot-scope="text">
          <img class="img-lc" :src="priorityIcon[text]" alt="" />
          <span>{{ priorityName[text] }}</span>
        </template>
        <template slot="description" slot-scope="text">
          <span :title="text" v-html="text"></span>
        </template>
        <template slot="state" slot-scope="text">
          <a-tag :color="text == 1 ?'green': 'red'">
            {{ text == 1? '启用' : '禁用'}}
          </a-tag>
        </template>
        <span slot="action" slot-scope="record" style="display: flex">
             <a-tooltip  content="" placement="top" effect="light" >
               <template slot="title">
                 <span>开始作业</span>
               </template>
               <i class="table-action ant-caret-icon" @click="restartUpOpen(record)"/>
            </a-tooltip>

          <a-dropdown placement="bottomRight" :trigger="['click']">
            <i class="ant-dropdown-link ant-dropdown-icon table-action"  />
            <a-menu slot="overlay">
              <a-menu-item v-if="$IA('system:schedule:update')" @click="addTriggerOpen('编辑', record)"
              >
                <i class="table-edit action_icon" ></i>
                <span>编辑</span></a-menu-item
              >
              <a-menu-item v-if="$IA('system:schedule:viewJob')" @click="seeJobOpen('查看', record)"
              >
              <i class="table-view action_icon" ></i>
                <span>查看作业</span></a-menu-item
              >
              <a-menu-item v-if="$IA('system:schedule:updateState')"
                           @click="stateSwitch('启用', record)"
                           :disabled="record.state == 1 ||  ( record.expiryDate  != null && ($moment().format('YYYY-MM-DD HH:mm:ss')>record.expiryDate) )"
              >
<!--                <a-icon type="check-circle" />-->
               <i class="table-batch_file action_icon" ></i>
                <span>启用</span></a-menu-item
              >
              <a-menu-item v-if="$IA('system:schedule:updateState')"
                           @click="stateSwitch('禁用', record)"
                           :disabled="record.state == 0 "
              >
              <i class="table-bulk_disable action_icon" ></i>
                <span>禁用</span></a-menu-item
              >
              <a-menu-item v-if="$IA('system:schedule:delete')" @click="handleOpen('删除', record)"
              ><i class="table-delected action_icon" ></i><span>删除</span></a-menu-item
              >
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </main>
    <!-- 操作模态框 -->
    <a-modal
        centered
        :title="false"
        :visible="triggerVisible"
        :confirm-loading="btnLoad"
        destroyOnClose
        @cancel="triggerVisible = false"
        width="750px"
        :footer="null"
        :maskClosable="false"
    >
      <a-row :gutter="24">
        <a-tabs :default-active-key="typeTrigger" size="large" @change="tabsChage">
          <a-tab-pane
              :key="3"
              v-if="(processEdit && processEdit.type == 3) || !processEdit"
          >
            <span slot="tab">
              <i class="ant-time-icon table-action"></i>
              时间
            </span>
            <zt-add-time
                @close="triggerVisible = false"
                @addTriggerSuccess="addTriggerSuccess"
                :processOne="processOne"
                :processEdit="processEdit"
            ></zt-add-time>
          </a-tab-pane>
          <a-tab-pane
              :key="4"
              v-if="(processEdit && processEdit.type == 4) || !processEdit"
          >
            <span slot="tab">
              <i class="ant-queue-icon table-action"></i>
              队列
            </span>
            <zt-add-queue
                @close="triggerVisible = false"
                @addTriggerSuccess="addTriggerSuccess"
                :processOne="processOne"
                :processEdit="processEdit"
                :processSign="processSign"
            ></zt-add-queue>
          </a-tab-pane>
          <a-tab-pane
              :key="5"
              v-if="this.processEdit == null"
          >
            <span slot="tab">
              <i class="ant-fille-icon table-action"></i>
              文件
            </span>
            <zt-add-queue
                @close="triggerVisible = false"
                @addTriggerSuccess="addTriggerSuccess"
                :processOne="processOne"
                :processEdit="processEdit"
                :processSign="processSign"
            ></zt-add-queue>
          </a-tab-pane>
          <a-tab-pane
              :key="6"
              v-if="this.processEdit  == null"
          >
            <span slot="tab">
              <i class="ant-email-icon table-action"></i>
              邮件
            </span>
            <zt-add-queue
                @close="triggerVisible = false"
                @addTriggerSuccess="addTriggerSuccess"
                :processOne="processOne"
                :processEdit="processEdit"
                :processSign="processSign"
            ></zt-add-queue>
          </a-tab-pane>
        </a-tabs>
      </a-row>
    </a-modal>

    <a-modal
        centered
        title="删除触发器"
        :visible="modalVisible"
        :confirmLoading="submitLoad"
        @ok="handleOk"
        width="420px"
        :maskClosable="false"
        @cancel="resetForm"
        :footer="modalTitle == '查看' ? null : undefined"
    >
      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该触发器,是否继续?</p>
      </div>
    </a-modal>

    <!-- 启动流程 -->
    <a-modal
        centered
        :title="'开始作业' + '：' + this.singleTriggerData.name"
        :visible="startUpTriggerVisible"
        width="700px"
        destroyOnClose
        :maskClosable="false"
        @cancel="jobResetForm"
        :confirm-loading="submitLoad"
        @ok="startUpSubmit"
        class="ant-start-modal"
    >
      <i class="ant-start-underline"></i>
      <a-form-model
          :rules="startUpRules"
          :model="startUpForm"
          ref="startUpForm"
      >
        <a-row :gutter="23">
          <a-col :span="15">
            <a-form-model-item label="部门" prop="orgName"  >
              <a-input v-model="startUpForm.orgName" disabled />
            </a-form-model-item>
          </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="是否录屏" prop="screenRecord"  >
                        <a-switch v-model="startUpForm.screenRecord" checked-children="开" un-checked-children="关" :checked="startUpForm.screenRecord == 1 ? true : false "  />
                      </a-form-model-item>
                    </a-col>
          <a-col :span="15" >
            <a-form-model-item label="流程" prop="processName"  >
              <a-input v-model="startUpForm.processName" disabled />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-model-item label="部门" prop="orgId">
              <a-tree-select v-model='startUpForm.orgId'
                 disabled
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="treeData" @change="treeChange"
                placeholder="选择部门" tree-default-expand-all :replaceFields="{ title: 'name', key: 'id', value: 'id' }">
              </a-tree-select>
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="15">
            <a-form-model-item label="流程" prop="processId">
              <a-select
                v-model="startUpForm.processId"
                placeholder="请选择"
                disabled
                @change="taskChange($event,'表单')"
                show-search
                :filter-option="filterOption"
              >
                <a-select-option
                  :key="item.id"
                  v-for="item in this.taskList"
                  :value="item.id"
                  :label="item.name"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <a-col :span="9">
            <a-form-model-item label="作业优先级" prop="priority">
              <a-select v-model="startUpForm.priority" placeholder="请选择">
                <a-select-option
                    v-for="(v, index) in priorityName"
                    :key="index"
                    :value="Number(index)"
                >
                  <img :src="priorityIcon[index]" style="margin-top: -5px" />
                  {{ v }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" tab="执行设备">
                <a-col :span="24">
                  <a-form-model-item prop="type" style="border-bottom: 1px solid #c7c7c7;margin:-10px 0 20px;">
                    <a-radio-group v-model="startUpForm.type">
                      <a-radio :value="1">特定机器人</a-radio>
                      <a-radio :value="2">动态分配</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24" v-if="startUpForm.type == 1">
                  <a-form-model :model="robotCondition" ref="searchRobotBar" :layout="formLayout" style="margin: 0px 0 15px;">
                    <a-form-model-item prop="searchText">
                      <a-input-search v-model.trim="robotCondition.searchText" placeholder="机器人/计算机"
                                      style="width: 200px;margin-top: 2px" allow-clear    @input="searchRobotTextChange" @search="robotSearchChange" />
                    </a-form-model-item>
                    <a-form-model-item prop="status">
                      <a-select v-model="robotCondition.status" placeholder="状态" style="width: 180px; "
                                allowClear @change="robotSearchChange">
                        <a-select-option :value="0">可用</a-select-option>
                        <a-select-option :value="1">断开连接</a-select-option>
                        <a-select-option :value="2">忙碌</a-select-option>
                        <a-select-option :value="3">无响应</a-select-option>
                      </a-select>
                    </a-form-model-item>

                    <a-form-model-item style="float: right;margin-right: 0px;">
                      <a-button icon="redo" @click="resetRobotSearch" size="small" >重 置</a-button>
                    </a-form-model-item>
                  </a-form-model>

                  <a-table :columns="robotColumns" :data-source="robotData"   :loading="robotTableLoad"   :pagination="robotCondition"  @change="robotTableChange"
                           width="400px" rowKey="id" :rowSelection="{
                      selectedRowKeys: selectedRowKeys,
                      onChange: onSelectChange,
                    }" :scroll="{ y: 130 }">
                    <template slot="name" slot-scope="text, record">
                      <img :src="statsIcon[record.status]" />
                      <span> {{ text }}</span>
                    </template>
                    <template slot="status" slot-scope="text">
                      <span> {{ statusName[text] }}</span>
                    </template>
                  </a-table>
                </a-col>
                <a-col :span="15" v-if="startUpForm.type == 2">
                  <a-form-model-item label="执行流程次数" prop="executeCount">
                    <a-input-number placeholder="请输入" style="width: 100%" v-model="startUpForm.executeCount" :min="1"
                                    :max="999" />
                  </a-form-model-item>
                </a-col>

              </a-tab-pane>
              <a-tab-pane key="2" tab="附加参数"  force-render>
                <a-col :span="24">
                  <a-table :columns="parameterColumns"  :data-source="startUpForm.parameter" :loading="btnLoad"
                           :pagination="false" :scroll="{ y: 140 }">
                    <template slot="argName" slot-scope="text, record, index">
                      <span>{{ text }}  <span style="color: red" v-if="record.required == 1">*</span> </span>
                    </template>
                    <template slot="defaultValue" slot-scope="text, record, index">
                      <a-form-model-item :prop="'parameter.' + index + '.defaultValue'"
                                         :rules="{ required: record.required == 1 , message: '请输入参数值', trigger: 'blur' }">
                        <a-input-number v-model="record.defaultValue" placeholder="请输入" :min="1" :max="999"
                                        v-if="record.argType === 1" style="width: 100%" />
                        <a-input v-model="record.defaultValue" placeholder="请输入"
                                 v-if="record.argType === 2 || record.argType === 4" />
                        <a-select v-model="record.defaultValue" placeholder="请输入" v-if="record.argType === 3">
                          <a-select-option value="true">是</a-select-option>
                          <a-select-option value="false">否</a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </template>
                  </a-table>
                </a-col>
              </a-tab-pane>
            </a-tabs>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>

    <!-- 提示框 -->
    <a-modal :visible="messageVisible" width="450px" :closable="false" @cancel="messageVisible = false" class="message-modal" :maskClosable="false">
      <template slot="footer">
        <a-button key="back" @click="messageVisible = false">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="submitLoad" @click="submitClick">
          确定
        </a-button>
      </template>
      <p style="padding:40px 20px 20px;margin-bottom:0px;font-weight:600;font-size: 16px;"><a-icon type="question-circle" style="color:#fa7900;margin-right:10px;font-size:18px" />{{batchText}}</p>
    </a-modal>
  </div>
</template>

<script>
import store from "@/store";
import {notification} from "ant-design-vue";

export default {
  computed: {
    rowtriggerSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {

          this.triggerData = selectedRows
          this.selectedJobRowKeys = selectedRowKeys;
        },
        getCheckboxProps: record => ({
          props: {
            disabled:null, // Column configuration not to be checked
          },
        }),
        selectedRowKeys: this.selectedJobRowKeys,
      };
    },
  },
  components: {
    // ztAddTime: () => import("./DL_adddTriggerTime.vue"),
    // ztAddQueue: () => import("./DL_addTriggerQueue.vue"),
  },
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      submitLoad: false,
      robotTableLoad: false,
      pagination: {
        searchText: "",
        type: undefined,
        orgId:undefined,
        state: undefined,
        priority: undefined,
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      switchApi: "",
      formLayout:"inline",
      queryCondition: {},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
          ellipsis: true,
        },
        {
          title: "流程",
          dataIndex: "processName",
          key: "processName",
          ellipsis: true,
        },
        {
          title: "部门",
          dataIndex: "orgName",
          key: "orgName",
          ellipsis: true,
        },
        {
          title: "环境",
          key: "environmentName",
          dataIndex: "environmentName",
          ellipsis: true,
        },
        {
          title: "机器人",
          key: "robotNames",
          dataIndex: "robotNames",
          ellipsis: true,
        },
        {
          title: "类型",
          key: "type",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
          ellipsis: true,
        },
        {
          title: "状态",
          key: "state",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
          ellipsis: true,
        },
        {
          title: "触发器详细信息",
          key: "description",
          dataIndex: "description",
          scopedSlots: { customRender: "description" },
          ellipsis: true,
          width: 180,
        },
        {
          title: "作业优先级",
          dataIndex: "priority",
          key: "priority",
          scopedSlots: { customRender: "priority" },
          ellipsis: true,
          align: 'center'
        },

        {
          title: "创建时间",
          key: "createTime",
          dataIndex: "createTime",
          ellipsis: true,
        },
        {
          title: "下次执行时间",
          key: "nextTime",
          dataIndex: "nextTime",
          scopedSlots: { customRender: "nextTime" },
          ellipsis: true,
          width: 180,
        },
        {
          title: "截止日期",
          key: "expiryDate",
          dataIndex: "expiryDate",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 85,
          scopedSlots: { customRender: "action" },
        },
      ],
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      triggerVisible: false,
      // 模态框标题
      modalTitle: "",
      // 部门列表
      treeData:[],
      // 类型字典
      typeName: {
        2: "时间",
        3: "队列",
        4: "邮件",
        5: "文件",
      },
      // 优先级字典
      priorityName: {
        0: "低",
        1: "中",
        2: "高",
        3: "已继承"
      },
      priorityIcon: {
        0: require("../assets/images/low.png"),
        1: require("../assets/images/normal.png"),
        2: require("../assets/images/height.png"),
        3: require("../assets/images/inherited.png"),
      },
      statsIcon: {
        0: require("../assets/images/newest.png"),
        1: require("../assets/images/break.png"),
        2: require("../assets/images/beBusy.png"),
      },
      // 流程列表
      taskList: [],
      // 单条流程信息
      processOne: "",
      // 编辑排班回显数据
      processEdit: "",
      // 触发器标志
      processSign:"",
      // 队列/时间
      typeTrigger: 3,
      // 单行数据
      singleDta: "",
      // 立即启动作业
      startUpTriggerVisible: false,
      // 单行数据
      singleTriggerData: {},
      startUpForm: {
        processId: undefined,
        processName:"",
        orgName:"",
        priority: 1,
        type: 1,
        screenRecord:false,
        robotIds: [],
        executeCount: 1,
        parameter: [],
      },
      startUpRules: {
        processId: [{ required: true, message: "流程不能为空" }],
        orgName: [{ required: true, message: "部门不能为空" }],
        processName: [{ required: true, message: "流程不能为空" }],
        priority: [{ required: true, message: "作业优先级不能为空" }],
        type: [{ required: true, message: "执行设备不能为空" }],
        executeCount: [{ required: true, message: "执行流程次数不能为空" }],
        screenRecord: [{ required: false, message: "是否录屏不能为空" }],

      },
      robotData: [],
      selectedRowKeys: [], //复选框数据
      statusName: {
        0: "可用",
        1: "断开连接",
        2: "忙碌",
        3: "无响应",
      },
      robotColumns: [
        {
          title: "机器人",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "计算机",
          dataIndex: "machineName",
          key: "machineName",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
      ],
      // 流程选中
      processSelection:{},
      // 附加参数
      parameterColumns: [
        {
          title: "参数名称",
          dataIndex: "argName",
          key: "argName",
          scopedSlots: { customRender: "argName" },
        },
        {
          title: "参数值",
          dataIndex: "defaultValue",
          key: "defaultValue",
          scopedSlots: { customRender: "defaultValue" },
        },
      ],
      // 分页参数
      pagCurrent:{},

      // 分配机器人
      robotCondition:{
        searchText: "",
        status:undefined,
        current: 1,
        pageSize: 5,
        pageNo: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '30', '40', '50'],
        showTotal: (total, range) => `共 ${total} 条记录  `,
        processId: "",
      },

      // 多选
      selectedJobRowKeys:[],
      messageVisible:false,
      batchText:'',
      triggerData:'',
      batchKey:''
    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
      if ( node.children == null ) {
        if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 下次执行时间显示
    nextTimeShow(data){
      if (data.state != 1){
        return '已禁用'
      }else if (data.type == 2 && data.state == 1) {
        return data.nextTime
      }
    },
    // 开启搜索
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 重置表单通用方法
    resetForm() {
      // this.$refs.addForm.resetFields();
      this.modalVisible = false;
    },

    // 重置表单通用方法
    jobResetForm() {
      this.robotData = []
      this.startUpTriggerVisible = false
      this.startUpForm.parameter = []
      this.selectedRowKeys = [];
    },
    // 重置搜索
    resetSearch(){
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },

    // 部门下拉框
    allorgList() {
      this.axios
          .post("/org/findOrg",'')
          .then((res) => {
            if (res.code === 200) {
              this.treeData = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.singleDta = data;
      switch (title) {
        case "查看":
          break;
        case "删除":
          break;
      }
    },
    // 提交
    handleOk() {
      if (this.modalTitle == "删除") {
        this.submitLoad = true;
        this.axios
            .delete("/schedule/delete", {
              params: {
                id: this.singleDta.id,
              },
            })
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange(this.pagCurrent);
                this.modalVisible = false;
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
      }
    },
    // 打开编辑触发器
    addTriggerOpen(title, editData) {
      this.$emit("open", editData.id,'触发器');

      this.$cookies.set('triggerQuery',JSON.stringify(this.pagination), "0", '/')
    },
    // 打开添加触发器
    addTriggerleont(oneData, editData) {
      this.$emit("open", oneData,'触发器');
      // this.processOne = null;
      // this.processEdit = null;
      // this.triggerVisible = true;
      // this.typeTrigger = 3;
      // this.tabsChage()
    },
    // 添加触发器成功的回调
    addTriggerSuccess(mes,data) {
      this.triggerVisible = false;
      notification.success({
        message:mes,
        duration: 3,
        customClass: "batch-import",
      })
      this.handleTableChange(data == null ? this.pagination:this.pagCurrent);
    },
    // 查看    子向父传
    seeJobOpen(title, data) {
      this.$emit("open", data,'查看作业');
      this.$cookies.set('triggerQuery',JSON.stringify(this.pagination), "0", '/')
    },
    // 立即启动
    restartUpOpen(data) {
      this.startUpTriggerVisible = true;
      this.singleTriggerData = data;
      this.startUpForm.id = data.id;
      this.startUpForm.priority = data.priority;
      this.startUpForm.executeCount = "";
      this.startUpForm.type = 1
      this.startUpForm.orgId = data.orgId
      this.startUpForm.orgName = data.orgName
      this.startUpForm.robotIds = data.robotIds
      this.robotCondition.status = undefined
      this.robotCondition.searchText = ''
      this.robotCondition.current = 1
      this.robotCondition.pageSize = 5
      this.robotCondition.total = 0



      this.againTaskList(data.processId)
      // this.treeChange(this.startUpForm.orgId)
      // this.startUpForm.processId = data.processId

    },
    // 重新执行流程下拉框
    againTaskList(id) {
      this.axios
          .post("/process/getById", this.$qs.stringify({id}))
          .then((res) => {
            if (res.code === 200) {
              this.startUpForm.processName = res.data.name
              this.startUpForm.processId = res.data.id
              this.parameterList(res.data)
              this.robotCondition.processId = res.data.id
              this.robotTableChange('','','',res.data)
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 启动提交
    startUpSubmit() {
      this.$refs.startUpForm.validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          let saveData = "";
          saveData = this.$lodash.cloneDeep(this.startUpForm);
          saveData.parameter = saveData.parameter
              ? JSON.stringify(saveData.parameter)
              : "";
          if (!saveData.screenRecord ){
            saveData.screenRecord = 0
          }else{
            saveData.screenRecord = 1
          }
          this.axios
              .post("/job/save", saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.startUpTriggerVisible = false;
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange(this.pagination);
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
        }else{
          this.$message.warning('请检查必填项(含附加参数)是否全部填写完成');
        }
      });
    },
    // 监听部门
    treeChange(val) {
      this.startUpForm.processId = undefined
      this.startUpForm.parameter = ''
      this.robotData = []
      this.axios
          .post("/process/findProcess", { orgId: val })
          .then((res) => {
            if (res.code === 200) {
              this.taskList = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 监听流程下拉框-选择机器人   放弃
    // taskChange(val) {
    //   let obj = this.taskList.find((item) => {
    //     return item.id === val;
    //   });
    //   // 附加参数
    //   this.parameterList(obj)
    //   // this.allRobotList(obj);
    //   this.robotTableChange('','','',obj)
    //   this.startUpForm.robotIds = undefined;
    // },
    // 特定机器人列表
    allRobotList() {
      this.robotTableLoad = true
      this.axios
          .post(
              "/robot/findRobotsByProcessId",
              this.robotCondition
          )
          .then((res) => {
            // console.log(res.data);
            this.robotTableLoad = false
            if (res.code === 200) {
              this.robotData = res.data.records;
              this.robotCondition.total = res.data.total;

              this.selectedRowKeys = this.singleTriggerData.robotIds
                  ? this.singleTriggerData.robotIds.split(",")
                  : [];
            }
          })
          .catch((err) => {
            this.robotTableLoad = false
            console.log(err);
          });
    },
    // 附加参数列表
    parameterList(data){
      this.axios
          .post(
              "/process/findProcessArgsByProcess",
              "versionId=" + data.versionId + "&processId=" + data.id
          )
          .then((res) => {
            if (res.code === 200) {
              this.startUpForm.parameter = res.data;
              console.log(     this.startUpForm.parameter )
              for (let i = 0; i < this.startUpForm.parameter.length; i++) {
                if (this.startUpForm.parameter[i].defaultValue) {
                  this.startUpForm.parameter[i].defaultValue = undefined;
                }else{
                  this.startUpForm.parameter[i].defaultValue = undefined;
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 状态切换
    stateSwitch(title, data) {
      switch (title) {
        case "启用":
          this.switchApi = "/schedule/enable";
          break;
        case "禁用":
          this.switchApi = "/schedule/disable";
          break;
      }
      this.axios
          .post(this.switchApi, "id=" + data.id)
          .then((res) => {
            // console.log(res.data);
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
              this.handleTableChange(this.pagination);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 流程下拉框
    allTaskList(orgId) {
      this.axios
          .post("/process/findProcess", { orgId: orgId })
          .then((res) => {
            if (res.code === 200) {
              this.taskList = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 监听触发器切换
    tabsChage(val){
      this.processSign = val
    },
    // 监听表格复选
    onSelectChange(selectedRowKeys, selectedRows) {
      let obj = [];
      selectedRows.forEach((element) => {
        obj.push(element.id);
      });
      this.startUpForm.robotIds = obj.length == 0 ? '' :  obj.join(",") ;
      this.selectedRowKeys = selectedRowKeys;
    },


    // 批量操作
    batchOpen(val){
      this.messageVisible = true
      this.batchKey = val
      switch (val){
        case 1:
          this.batchText = '是否启用所选触发器?'
          this.batchApi = 'schedule/enableBatch'
          break
        case 0:
          this.batchText = '是否禁用所选触发器?'
          this.batchApi = 'schedule/disableBatch'
          break
        case 3:
          this.batchText = '是否删除所选触发器?'
          this.batchApi = 'schedule/deleteBatch'
          break
      }

    },
    // 批量提交
    submitClick(){
      let subDis = true,tipsDis = false,tips = '';

      this.triggerData.forEach((item)=>{
        if (item.state == this.batchKey){
          subDis  = false
          tipsDis = true
        }
      })

      switch (this.batchKey){
        case 1:
          tips = '存在数据【已启用】为不可提交！'
          break
        case 0:
          tips = '存在数据【已禁用】为不可提交！'
          break
      }
      if (tipsDis){
        notification.success({
          message:tips,
          duration: 3,
          customClass: "batch-import",
        })
      }

      if (subDis){
        this.submitLoad = true
        this.axios
            .post(this.batchApi,this.selectedJobRowKeys )
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                notification.success({
                  message:res.data,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange(this.pagination);
                this.messageVisible = false
                this.selectedJobRowKeys = []
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
      }
    },
    // 监听搜索输入框输入
    searchTextChange(val){
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 重置搜索
    resetRobotSearch() {
      this.$refs.searchRobotBar.resetFields()
      this.robotCondition.current = 1
      this.robotCondition.pageNo = 1
      this.robotSearchChange()
    },
    searchRobotTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.robotSearchChange(val)
      }, 1200);
    },

    // 搜索
    robotSearchChange(v) {
      this.robotCondition = this.$lodash.cloneDeep(this.robotCondition)
      this.robotCondition.current = 1
      this.robotCondition.pageNo = 1
      this.allRobotList()
    },

    // 监听分配机器表格翻页
    robotTableChange(pagination, filters, sorter) {
      this.robotCondition.pageNo = pagination.current ? pagination.current : 1
      this.robotCondition.current = pagination.current ? pagination.current : 1
      this.robotCondition.pageSize = pagination.pageSize ? pagination.pageSize : 5

      this.selectedRowKeys = []
      // this.startUpForm.robotIds = undefined
      this.allRobotList()
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo = pagination.current
      this.queryCondition.current = pagination.current
      this.queryCondition.pageSize = pagination.pageSize
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true;
      this.axios
          .post("/schedule/findPage", this.$qs.stringify(this.queryCondition))
          .then((res) => {
            this.tableLoad = false;
            if (res.code === 200) {
              this.tableData = res.data.records;
              this.queryCondition.total = res.data.total;
            }
          })
          .catch((err) => {
            console.log(err);
            this.tableLoad = false;
          });
    },
  },
  watch:{
    taskList(n,o){
      let obj = this.taskList.find((item) => {
        return item.id === this.startUpForm.processId;
      });
      // 附加参数
      this.parameterList(obj)
      // this.allRobotList(obj);
      this.robotTableChange('','','',obj)
    }
  },
  beforeMount() {
    this.$nextTick(()=>{
      let query = this.$cookies.get('triggerQuery')
      if (query){
        query.showTotal  = (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
        this.pagination = query ? query : this.pagination
      }
      this.allorgList()
      this.searchChange();
      this.$cookies.remove('triggerQuery' )
    })

  },
};
</script>

<style lang="scss" scoped>
.main-trigger {

  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        width: 100%;
        .ant-form-item{
        }
        .ant-form-item:last-child{
          margin-right: 0px;



          .ant-btn{
            margin-right: 15px;
            i{
              margin:0 10px 0 0px;
              padding: 0px;
            }
          }
          .ant-btn:last-child{
            margin-right: 0px;
          }

        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
    .btn-group{
      i{
        padding: 0px 0px 0px 0px;
        margin-right: 10px;
      }
      .ant-btn{
        margin-right: 15px;
      }
      .ant-btn:last-child{
        margin-right: 0px;
      }


      .ant-btn[disabled]{
        i.table-batch_file { background-image: url('../assets/images/icon_btn/batch_file_disabled.png'); }
        i.table-bulk_disable { background-image: url('../assets/images/icon_btn/bulk_disable_disabled.png'); }
        i.table-delected { background-image: url('../assets/images/icon_btn/deleted_default_disabled.png'); }
      }

    }
    i.ant-caret-icon {
      background: url("../assets/images/icon_btn/Run.png") no-repeat center;
    }
    i.ant-dropdown-icon {
      background: url("../assets/images/Table_action.png") no-repeat center;
    }
    i.table-action {
      cursor: pointer;
      display: inline-block;
      margin: -5px 0;
      width: 30px;
      height: 30px;
      border-radius: 20px;
      vertical-align: top;
      &:active {
        background-color: #d8e6ff;
      }
    }

    .img-lc {
      vertical-align: middle;
      margin-right: 5px;
      margin-top: -3px;
    }
  }
}
i.ant-time-icon {
  background: url("../assets/images/time_default.png") no-repeat center;
}
i.ant-queue-icon {
  background: url("../assets/images/Queue_default.png") no-repeat center;
}
i.ant-fille-icon {
  background: url("../assets/images/folder_default.png") no-repeat center;
}
i.ant-email-icon {
  background: url("../assets/images/email_default.png") no-repeat center;
}
i.table-action {
  cursor: pointer;
  display: inline-block;
  margin: -3px 0 0 0;
  width: 30px;
  height: 30px;
  border-radius: 20px;
  vertical-align: top;
  padding:0px ;
  transition: 0.3s;
}
.ant-tabs-nav .ant-tabs-tab-active {
  transition: 0.3s;
  span {
    .ant-time-icon {
      background: url("../assets/images/time_selected.png") no-repeat center;
    }
    .ant-queue-icon {
      background: url("../assets/images/queue_selected.png") no-repeat center;
    }
    .ant-fille-icon {
      background: url("../assets/images/folder_selected.png") no-repeat center;
    }
    .ant-email-icon {
      background: url("../assets/images/email_selected.png") no-repeat center;
    }
  }
}
.ant-tabs-nav .ant-tabs-tab:hover {
  span {
    .ant-time-icon {
      background: url("../assets/images/time_selected.png") no-repeat center;
    }
    .ant-queue-icon {
      background: url("../assets/images/queue_selected.png") no-repeat center;
    }
    .ant-fille-icon {
      background: url("../assets/images/folder_selected.png") no-repeat center;
    }
    .ant-email-icon {
      background: url("../assets/images/email_selected.png") no-repeat center;
    }
  }
}

// tabs切换样式
::v-deep .ant-tabs {
  .ant-tabs-content {
    // padding: 0 12px;

    // 输入框样式
    .ant-form-item {
      .ant-form-item-label {
        label {
          font-weight: normal;
          color: #667a95;
        }
      }
      // 输入框样式
      .ant-input,
      .ant-input-number,
      .ant-time-picker-input {
        border: none;
        padding: 0px;
        border-radius: 0px;
        border-bottom: 1px solid #c7c7c7;
      }
      .ant-input:focus,
      :hover {
        box-shadow: none;
        border-bottom-color: #40a9ff;
      }
      // 下拉框激活状态颜色
      .ant-select-open .ant-select-selection {
        border-color: #fff;
        border-bottom-color: #40a9ff;
      }
      .ant-input-number-input {
        padding: 0px;
      }
      .ant-input-number-focused {
        box-shadow: none;
        border-bottom-color: #40a9ff;
      }
      // 边框线颜色
      .ant-select-selection {
        border: none;
        border-radius: 0px;
        border-bottom: 1px solid #c7c7c7;
      }
      // 下拉框阴影
      .ant-select-selection--single {
        box-shadow: none;
      }
      // 下拉框hover效果
      .ant-select-selection:hover {
        border-color: #fff;
        border-bottom-color: #40a9ff;
        border-right-width: 1px !important;
      }
      // 字体左边间距
      .ant-select-selection__rendered {
        margin-left: 0px;
      }
      .has-error .ant-select-selection {
        border-bottom-color: #f5222d;
      }
      //触发器
      .trigger-checkbox-group {
        border: 1px solid #c7c7c7;
        padding: 4px 3px;
        .ant-checkbox-wrapper {
          margin: 9px 11.5px;
        }
      }
      .ant-popover-inner {
        margin: 20px;
      }
    }
  }
}
// 切换框
::v-deep .ant-tabs-nav {
  width: 100%;

  .ant-tabs-tab {
    width: 50%;
    text-align: center;
  }

  .ant-tabs-tab:nth-child(1) {
    margin: 0px;
  }

  .ant-tabs-tab-active {
    background-color: #fafafa;
    font-weight: 600;
  }
}

.ant-start-modal {

  ::v-deep .ant-modal {

    .ant-modal-body {

      .ant-form-item {
        margin-bottom: 0px;
        // 下拉框激活状态颜色
        .ant-select-open .ant-select-selection {
          border-color: #fff;
          border-bottom-color: #40a9ff;
        }

        // 边框线颜色
        .ant-select-selection {
          border: none;
          border-radius: 0px;
          border-bottom: 1px solid #c7c7c7;
        }

        // 下拉框阴影
        .ant-select-selection--single {
          box-shadow: none;
        }

        // 下拉框hover效果
        .ant-select-selection:hover {
          border-color: #fff;
          border-bottom-color: #40a9ff;
          border-right-width: 1px !important;
        }

        // 字体左边间距
        .ant-select-selection__rendered {
          margin-left: 0px;
        }

        // 计数器样式
        .has-error .ant-select-selection {
          border-bottom-color: #f5222d;
        }

        // 激活样式
        .ant-input-number:focus {
          box-shadow: none;
          border-bottom-color: #40a9ff;
        }

        .has-error .ant-input-number-focused {
          box-shadow: none;
          border-bottom-color: #f5222d;
        }

        .ant-input-number-focused {
          box-shadow: none;
          border-bottom-color: #40a9ff;
        }

        .ant-input-number-input,.ant-input {
          padding: 0;
        }
        .ant-input-number,.ant-input {
          border: none;
          border-radius: 0px;
          border-bottom: 1px solid #c7c7c7;
          border-bottom-color: #c7c7c7 !important;
        }
        .ant-input:hover {
          border-bottom-color: #40a9ff !important;
        }
        .ant-input:focus{
          box-shadow: 0 0 0px rgba(24, 144, 255, 0.2);
          border-bottom-color: #40a9ff !important;
        }
        // 禁用
        .ant-select-disabled .ant-select-selection,.ant-input-disabled {
          background: transparent;
          border-bottom: 1px dashed #c7c7c7;
        }
      }


    }

    .ant-table-thead>tr>th {
      background: #fafafa;
    }
  }
}

</style>